module.exports = __webpack_public_path__ + "media/images/color_admin_v3/product/product-5-00344ff423124e08dcc0a2acf44d729d.png";